<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Vendor" subTitle="List" />

    <ListVendor />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import ListVendor from "@/components/Pages/Master/Vendor/ListVendor.vue";

export default defineComponent({
  name: "ListVendorPage",
  components: {
    PageTitle,
    ListVendor,
  },
});
</script>
